import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: {
    unit: 'Review 4',
    id: 'WB3-PV4-P86-E1',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page86/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page86/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page86/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/3.jpg', input: true, answer: "smaller than" },
        { url: 'img/FriendsPlus/Page86/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page86/E1/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page86/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/7.jpg', input: true, answer: "faster than" },
        { url: 'img/FriendsPlus/Page86/E1/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page86/E1/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page86/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/11.jpg', input: true, answer: "louder than" },
        { url: 'img/FriendsPlus/Page86/E1/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page86/E1/13.jpg' },
      ],


    ]
  },
  2: {
    unit: 'Review 4',
    id: 'WB3-PV4-P86-E2',
    audio: '',
    video: '',
    component: D1,
    checkDuplicated: true,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page86/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page86/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page86/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/3.jpg', input: true, answer: "dry/good/wet/happy/loud/tall/small" },
        { url: 'img/FriendsPlus/Page86/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/5.jpg', input: true, answer: "cow/goat/horse/sheep/rabbit/donkey/goose/chick" },
        { url: 'img/FriendsPlus/Page86/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/7.jpg', input: true, answer: "cow/goat/horse/sheep/rabbit/donkey/goose/chick" },
        { url: 'img/FriendsPlus/Page86/E2/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page86/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/10.jpg', input: true, answer: "dry/good/wet/happy/loud/tall/small" },
        { url: 'img/FriendsPlus/Page86/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/12.jpg', input: true, answer: "dry/good/wet/happy/loud/tall/small" },
        { url: 'img/FriendsPlus/Page86/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/14.jpg', input: true, answer: "cow/goat/horse/sheep/rabbit/donkey/goose/chick" },
        { url: 'img/FriendsPlus/Page86/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/16.jpg', input: true, answer: "cow/goat/horse/sheep/rabbit/donkey/goose/chick" },
        { url: 'img/FriendsPlus/Page86/E2/17.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page86/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/19.jpg', input: true, answer: "dry/good/wet/happy/loud/tall/small" },
        { url: 'img/FriendsPlus/Page86/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/21.jpg', input: true, answer: "dry/good/wet/happy/loud/tall/small" },
        { url: 'img/FriendsPlus/Page86/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/23.jpg', input: true, answer: "cow/goat/horse/sheep/rabbit/donkey/goose/chick" },
        { url: 'img/FriendsPlus/Page86/E2/24.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/25.jpg', input: true, answer: "cow/goat/horse/sheep/rabbit/donkey/goose/chick" },
        { url: 'img/FriendsPlus/Page86/E2/26.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page86/E2/27.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/28.jpg', input: true, answer: "dry/good/wet/happy/loud/tall/small" },
        { url: 'img/FriendsPlus/Page86/E2/29.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/30.jpg', input: true, answer: "dry/good/wet/happy/loud/tall/small" },
        { url: 'img/FriendsPlus/Page86/E2/31.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/32.jpg', input: true, answer: "cow/goat/horse/sheep/rabbit/donkey/goose/chick" },
        { url: 'img/FriendsPlus/Page86/E2/33.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/34.jpg', input: true, answer: "cow/goat/horse/sheep/rabbit/donkey/goose/chick" },
        { url: 'img/FriendsPlus/Page86/E2/35.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page86/E2/36.jpg' },
      ],



    ]
  },




}
export default json;